'use strict';
/**
 *  Module
 *
 * Description
 */
angular.module('eventQueuesModalServiceModule', ['eventQueuesModalModule'])
    .factory('eventQueuesModalService', ["$modal", "$q", function($modal, $q) {
    	return{
            /**
             * [createNewReport description] 弹出队列详情
             * @return {[type]}          [description]
             */
    		newCreatQueues: function(item){
    			var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/logManageMent/eventMonitoring/service/eventQueuesModal/main_tpl.html",
                    windowClass: 'eventQueuesModal_window',
                    backdrop: false,
                    controller: "eventQueuesModalCtrl",
                    resolve: {
                        eventQuedata: function() {
                            return {
                                item:item
                            };
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
    		}
    	};
    }]);